import * as yup from 'yup';

export const AssertionsSetEditorValidationSchema = yup.object({
	name: yup
		.string()
		.required('assertions.validation.as_set_name_required')
		.max(50, 'assertions.validation.as_set_name_too_long'),
});
